import type { Account } from '../account';
import { MutableEntity } from '../common';
import { MongoId } from '../MongoId';
import { Organization } from '../organization';

export type OrganizationKarteMapping = MutableEntity & {
  rtOrganizationId: Organization.Id;
  karteOrganizationId: OrganizationKarteMapping.KarteOrganizationId;
};

export namespace OrganizationKarteMapping {
  export type KarteOrganizationId = MongoId;
  export namespace KarteOrganizationId {
    export const FromString = (id: string): KarteOrganizationId => MongoId.FromString(id) as KarteOrganizationId;
  }

  export type Props = MutableEntity.Props & {
    rtOrganizationId: string;
    karteOrganizationId: string;
  };

  export const Construct = (props: Props): OrganizationKarteMapping => {
    return {
      ...MutableEntity.Construct(props),
      rtOrganizationId: Organization.Id.FromString(props.rtOrganizationId),
      karteOrganizationId: KarteOrganizationId.FromString(props.karteOrganizationId),
    };
  };

  export namespace Create {
    export type Props = Pick<OrganizationKarteMapping, 'rtOrganizationId' | 'karteOrganizationId'>;
    export type Params = {
      operatorId: Account.Id;
      props: Props;
    };
  }
  export const Create = ({ operatorId, props }: Create.Params): OrganizationKarteMapping => {
    return {
      ...MutableEntity.Create({ operatorId }),
      rtOrganizationId: props.rtOrganizationId,
      karteOrganizationId: props.karteOrganizationId,
    };
  };

  export namespace Update {
    export type UpdatableKey = 'karteOrganizationId';
    export type UpdateProps = Partial<Pick<OrganizationKarteMapping, UpdatableKey>>;
    export type Params = {
      operatorId: Account.Id;
      cur: OrganizationKarteMapping;
      updateProps: UpdateProps;
    };
  }
  export const Update = ({ operatorId, cur, updateProps }: Update.Params): OrganizationKarteMapping => {
    return {
      ...cur,
      ...MutableEntity.Update({ cur, operatorId }),
      ...updateProps,
    };
  };
}
